import { ChangeDetectorRef, Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { Basket as NBasket } from '@df/basket/basket.interfaces';
import { App } from '@df/core/app';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { Basket } from '@df/session/api/basket/basket';
import { Customer } from '@df/session/api/customer';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BasketViewComponentDef<TBasket extends Basket = Basket> implements OnDestroy, OnInit {
    protected subscriptions: Subscription = new Subscription();

    isInStock = true;
    isSalable = true;
    isVirtual = false;
    basketSubscription: Subscription;

    basket = inject(Basket) as TBasket;

    constructor(
        protected _ref: ChangeDetectorRef,
        readonly app: App,
        private customer: Customer
    ) {
        this.basketSubscription = this.basket.subscribe(() => {
            this.onCustomerUpdate();
            this._ref.detectChanges();
        });

        this.onCustomerUpdate();
    }

    ngOnInit() {
        this.sendBasketViewEvent();
    }

    protected sendBasketViewEvent() {
        this.app.events.broadcast(NBasket.EVENTS.view);
    }

    ngOnDestroy() {
        if (this.basketSubscription) {
            this.basketSubscription.unsubscribe();
        }

        this.subscriptions.unsubscribe();
    }

    protected onCustomerUpdate() {
        this.isSalable = this.basket.isSalable;
        this.isInStock = this.basket.isInStock;
        this.isVirtual = this.basket.isVirtual;
    }

    trackByItemId(index: number, item: BasketItem) {
        return item.id;
    }

    get warning(): string | undefined {
        const beErrors = this.basket.data.errors;
        if (beErrors?.length) {
            return beErrors[0];
        }

        if (!this.isSalable) {
            return 'To proceed to checkout please remove out of stock products from your basket';
        }
    }
}
